import React from 'react';
import './DisasterMessageCard.css';

const DisasterMessageCard = ({ message, onClick, isMissingPerson }) => {
  // 내부 디버깅용 로그
  console.log('DisasterMessageCard에 전달된 메시지:', message);

  // 메시지 데이터 확인 및 추출
  let actualMessage = message;

  // 메시지 객체 구조 파악 및 데이터 추출
  // 1. 메시지 객체가 body 배열을 포함하는 경우
  if (message && message.body && Array.isArray(message.body) && message.body.length > 0) {
    actualMessage = message.body[0];
    console.log('message.body 배열에서 첫 번째 항목 추출:', actualMessage);
  }
  // 2. 메시지 자체가 배열인 경우 
  else if (Array.isArray(message) && message.length > 0) {
    actualMessage = message[0];
    console.log('message 배열에서 첫 번째 항목 추출:', actualMessage);
  }
  // 3. header와 body 구조인 경우 (API 응답 형태)
  else if (message && message.header && message.body) {
    actualMessage = message;
    console.log('message 객체 그대로 사용 (header/body 구조):', actualMessage);
  }

  // 메시지 내용, 지역, 날짜, 유형 등 필요한 정보 추출
  const messageContent = actualMessage?.MSG_CN || actualMessage?.msg || '';
  const region = actualMessage?.RCPTN_RGN_NM || actualMessage?.areaName || '';
  const date = actualMessage?.CRT_DT || actualMessage?.create_date || '';
  const disasterType = actualMessage?.DST_SE_NM || actualMessage?.type || '';

  // 발신 기관 추출
  const extractAgency = (content) => {
    if (!content) return '';

    const matches = content.match(/\[(.*?)\]/);
    if (matches && matches.length > 1) {
      return matches[1];
    }

    return '';
  };

  // 날짜 형식 변환 함수
  const formatDate = (dateStr) => {
    if (!dateStr) return '';

    // CRT_DT 형식 (2023/09/16 11:09:49) 처리
    if (dateStr.includes('/')) {
      return dateStr;
    }

    // YYYYMMDD 형식 처리
    if (dateStr.length === 8) {
      return `${dateStr.substring(0, 4)}-${dateStr.substring(4, 6)}-${dateStr.substring(6, 8)}`;
    }

    return dateStr;
  };

  // 텍스트 줄임 함수
  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  // 발신 기관
  const agency = extractAgency(messageContent);

  // 표시할 재난 유형 (실종자 메시지인 경우 '실종/미아'로 표시)
  const displayType = isMissingPerson ? '실종/미아' : (disasterType || '재난문자');

  // 카드 클래스 (실종자 메시지에는 다른 스타일 적용)
  const cardClassName = `disaster-card ${isMissingPerson ? 'missing-person' : ''}`;

  // 디버깅: 렌더링 전 최종 데이터 확인
  console.log('메시지 카드 최종 데이터:', {
    content: messageContent ? (messageContent.substring(0, 30) + '...') : '',
    region,
    date,
    type: displayType,
    agency
  });

  // 메시지 객체가 유효하지 않은 경우 빈 카드 반환
  if (!actualMessage || (typeof actualMessage === 'object' && Object.keys(actualMessage).length === 0)) {
    console.warn('유효하지 않은 메시지 객체:', message);
    return null;
  }

  // 중요: onClick에 원본 message가 아닌 정제된 actualMessage 전달하도록 수정
  return (
    <div className={cardClassName} onClick={() => onClick(actualMessage)}>
      <div className="disaster-card-header">
        <span className="disaster-type">{displayType}</span>
        <span className="disaster-date">{formatDate(date)}</span>
      </div>

      <div className="disaster-card-body">
        <p className="disaster-message">
          {messageContent.length > 100 ? truncateText(messageContent, 100) : messageContent}
        </p>

        {messageContent.length > 100 && (
          <span className="view-more">
            더보기
          </span>
        )}
      </div>

      <div className="disaster-card-footer">
        <div className="agency-info">
          <span className="agency-label">발신:</span>
          <span className="agency-name">{agency || '미상'}</span>
        </div>
        <span className="disaster-region">{region}</span>
      </div>
    </div>
  );
};

export default DisasterMessageCard;